import * as React from 'react';
import { Radio, RadioProps } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

/**
 * Source: ClientApp2/src/components/forms/CustomRadio.tsx (BlueprintJS style) — adapted for v4.
 * Default: primary fill (teal). For single selection in the Fleet offer, use
 * color="secondary" for the orange dot (as in the mockup).
 */
const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    borderRadius: '50%',
    width: 21,
    height: 21,
    boxShadow: `inset 0 0 0 1px ${theme.palette.grey[300]}`,
    backgroundColor: 'transparent',
    'input:disabled ~ &': { boxShadow: 'none', background: theme.palette.grey[100] }
  },
  checkedIconBase: { boxShadow: 'none' },
  dot: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 21,
      content: '""',
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)'
    }
  },
  colorPrimary: { backgroundColor: theme.palette.primary.main },
  colorSecondary: { backgroundColor: theme.palette.secondary.main }
}));

const CustomRadio: React.FC<RadioProps> = ({ color, ...props }) => {
  const classes = useStyles();
  const fill = color === 'secondary' ? classes.colorSecondary : classes.colorPrimary;
  return (
    <Radio
      disableRipple
      color="default"
      icon={<span className={classes.icon} />}
      checkedIcon={<span className={`${classes.icon} ${classes.checkedIconBase} ${classes.dot} ${fill}`} />}
      {...props}
    />
  );
};

export default CustomRadio;
